module.exports = __webpack_public_path__ + "img/DIVINOPOLIS - SETCEMG.f99e369c.png";